module.exports = __webpack_public_path__ + "media/images/lane/tablet_shadow-acf6bed633659130f2118bd8d6dfd3ab.png";